import { AxiosResponse } from 'axios';
import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';

export default class HealthCheckService {
  public static async checkNetworkBaseline(): Promise<number | null> {
    const start = performance.now();
    try {
      await ApiController.get(ApiRoutes.health) as AxiosResponse;
      const durationMs = Math.round(performance.now() - start);
      return durationMs;
    } catch (e) {
      return null;
    }
  }
}